<template>
  <v-dialog v-model="showModal" :max-width="'50%'" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="'primary-main lighten-'" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white text-center">
          What do you want to do?
          <v-btn class="" icon="mdi-close" variant="text" @click="showModal = false"></v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="flex pa-4 black--text">
        <div class="py-2 px-4 text-sm">
          <div class="grid gap-2 grid-cols-6">
            <div v-for="item in homeTopNavLinks" :key="item.id" @click="goTo(item.id)"
              class="cursor-pointer p-3 border flex flex-col items-center !border-gray-200 hover:text-primary-main rounded-md hover:!border-primary-main duration-200 nav-link">
              <div class="h-7 w-7 grid place-items-center">
                <component :is="item.icon" />
              </div>
              <span class="text-sm text-center mt-2">{{ item.featured?.text ?? item.title }}</span>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="w-full flex justify-center p-3">
          <v-btn variant="flat"
            class="!py-3 !bg-primary-main/80 !text-white mr-4 mb-1 !rounded-xl !tracking-normal !capitalize !h-auto min-w-[120px]"
            @click.stop="cancel">
            Something Else
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';
import { homeTopNavLinks } from '@/utils/homeLinks';
export default class Featured extends Vue {
  mounted() { }

  @Prop()
  public isReferral: boolean = false;

  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  public homeTopNavLinks: any = homeTopNavLinks.filter(module => module?.featured?.active);

  get showModal() {
    return this.isReferral;
  }

  set showModal(newValue) {
    this.$emit('update:modelValue', newValue);
  }

  public goTo(module: string) {
    this.cancel();
    this.payloadStore.change({ selectedModule: module });
  }

  public selectedIndex: number = 0;

  public cancel() {
    this.payloadStore.change({ selectedModule: '' });
    this.showModal = false;
    localStorage.setItem('tour-status', 'inactive');
  }
}
</script>
<style scoped lang="css">
.nav-link:hover svg,
.nav-link:hover .nav-link-icon,
.nav-link:hover .svg-path {
  fill: #1890ff !important;
}

</style>

<style>
.nav-link:hover svg path {
  stroke: #1890ff !important;
}
</style>